"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAGUE_CARD_MANIFEST = void 0;
var CardName_1 = require("../../CardName");
var GameModule_1 = require("../../GameModule");
var CardManifest_1 = require("../CardManifest");
var AmphibianFarming_1 = require("./league_project/AmphibianFarming");
var Apophis_1 = require("./league_corporation/Apophis");
var AssemblyLines_1 = require("./league_project/AssemblyLines");
var BankUnions_1 = require("./league_project/BankUnions");
var BoringvillePopulationYou_1 = require("./league_project/BoringvillePopulationYou");
var DNAExtractionFromSoil_1 = require("./league_project/DNAExtractionFromSoil");
var DactylAndIda_1 = require("./league_project/DactylAndIda");
var DelayedEntry_1 = require("./league_project/DelayedEntry");
var EdibleFungi_1 = require("./league_project/EdibleFungi");
var FireSale_1 = require("./league_project/FireSale");
var FirstContact_1 = require("./league_preludes/FirstContact");
var HeavyMetalBioremediation_1 = require("./league_project/HeavyMetalBioremediation");
var Incinerator_1 = require("./league_project/Incinerator");
var InvestmentBanks_1 = require("./league_project/InvestmentBanks");
var JovianOutpost_1 = require("./league_preludes/JovianOutpost");
var LaboratoryMice_1 = require("./league_project/LaboratoryMice");
var ManOfThePeople_1 = require("./league_preludes/ManOfThePeople");
var MarsHeavyIndustry_1 = require("./league_project/MarsHeavyIndustry");
var MatingSeason_1 = require("./league_project/MatingSeason");
var NoMonNoCryInsurance_1 = require("./league_project/NoMonNoCryInsurance");
var OuterRimUniversity_1 = require("./league_project/OuterRimUniversity");
var PhobosSpaceHavenLeague_1 = require("./league_project/PhobosSpaceHavenLeague");
var RecycledProjects_1 = require("./league_project/RecycledProjects");
var SaveOurShip_1 = require("./league_project/SaveOurShip");
var Scavengers_1 = require("./league_corporation/Scavengers");
var SoilEnhancers_1 = require("./league_project/SoilEnhancers");
var SpaceDebrisCollection_1 = require("./league_project/SpaceDebrisCollection");
var SteelCasting_1 = require("./league_project/SteelCasting");
var SulphuricImport_1 = require("./league_project/SulphuricImport");
var TargetedTurmoil_1 = require("./league_project/TargetedTurmoil");
var TitaniumIsotopes_1 = require("./league_project/TitaniumIsotopes");
var WorldGovernmentPartnership_1 = require("./league_project/WorldGovernmentPartnership");
exports.LEAGUE_CARD_MANIFEST = new CardManifest_1.CardManifest({
    module: GameModule_1.GameModule.League,
    projectCards: [
        { cardName: CardName_1.CardName.AMPHIBIAN_FARMING, Factory: AmphibianFarming_1.AmphibianFarming },
        { cardName: CardName_1.CardName.ASSEMBLY_LINES, Factory: AssemblyLines_1.AssemblyLines },
        { cardName: CardName_1.CardName.BANK_UNIONS, Factory: BankUnions_1.BankUnions },
        { cardName: CardName_1.CardName.BORINGVILLE_POPULATION_YOU, Factory: BoringvillePopulationYou_1.BoringvillePopulationYou },
        { cardName: CardName_1.CardName.DACTYL_AND_IDA, Factory: DactylAndIda_1.DactylAndIda },
        { cardName: CardName_1.CardName.DELAYED_ENTRY, Factory: DelayedEntry_1.DelayedEntry },
        { cardName: CardName_1.CardName.DNA_EXTRACTION_FROM_SOIL, Factory: DNAExtractionFromSoil_1.DNAExtractionFromSoil },
        { cardName: CardName_1.CardName.EDIBLE_FUNGI, Factory: EdibleFungi_1.EdibleFungi },
        { cardName: CardName_1.CardName.FIRE_SALE, Factory: FireSale_1.FireSale },
        { cardName: CardName_1.CardName.HEAVY_METAL_BIOREMEDIATION, Factory: HeavyMetalBioremediation_1.HeavyMetalBioremediation },
        { cardName: CardName_1.CardName.INCINERATOR, Factory: Incinerator_1.Incinerator },
        { cardName: CardName_1.CardName.INVESTMENT_BANKS, Factory: InvestmentBanks_1.InvestmentBanks },
        { cardName: CardName_1.CardName.LABORATORY_MICE, Factory: LaboratoryMice_1.LaboratoryMice },
        { cardName: CardName_1.CardName.MARS_HEAVY_INDUSTRY, Factory: MarsHeavyIndustry_1.MarsHeavyIndustry },
        { cardName: CardName_1.CardName.MATING_SEASON, Factory: MatingSeason_1.MatingSeason },
        { cardName: CardName_1.CardName.OUTER_RIM_UNIVERSITY, Factory: OuterRimUniversity_1.OuterRimUniversity },
        { cardName: CardName_1.CardName.NOMON_NOCRY_INSURANCE, Factory: NoMonNoCryInsurance_1.NoMonNoCryInsurance },
        { cardName: CardName_1.CardName.PHOBOS_SPACE_HAVEN_LEAGUE, Factory: PhobosSpaceHavenLeague_1.PhobosSpaceHavenLeague },
        { cardName: CardName_1.CardName.RECYCLED_PROJECTS, Factory: RecycledProjects_1.RecycledProjects },
        { cardName: CardName_1.CardName.SAVE_OUR_SHIP, Factory: SaveOurShip_1.SaveOurShip },
        { cardName: CardName_1.CardName.SOIL_ENHANCERS, Factory: SoilEnhancers_1.SoilEnhancers },
        { cardName: CardName_1.CardName.SPACE_DEBRIS_COLLECTION, Factory: SpaceDebrisCollection_1.SpaceDebrisCollection },
        { cardName: CardName_1.CardName.STEEL_CASTING, Factory: SteelCasting_1.SteelCasting },
        { cardName: CardName_1.CardName.SULPHURIC_IMPORT, Factory: SulphuricImport_1.SulphuricImport },
        { cardName: CardName_1.CardName.TARGETED_TURMOIL, Factory: TargetedTurmoil_1.TargetedTurmoil, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.TITANIUM_ISOTOPES, Factory: TitaniumIsotopes_1.TitaniumIsotopes },
        { cardName: CardName_1.CardName.WORLD_GOVERNMENT_PARTNERSHIP, Factory: WorldGovernmentPartnership_1.WorldGovernmentPartnership },
    ],
    preludeCards: [
        { cardName: CardName_1.CardName.FIRST_CONTACT, Factory: FirstContact_1.FirstContact, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.JOVIAN_OUTPOST, Factory: JovianOutpost_1.JovianOutpost },
        { cardName: CardName_1.CardName.MAN_OF_THE_PEOPLE, Factory: ManOfThePeople_1.ManOfThePeople, compatibility: GameModule_1.GameModule.Turmoil },
    ],
    corporationCards: [
        { cardName: CardName_1.CardName.APOPHIS, Factory: Apophis_1.Apophis },
        { cardName: CardName_1.CardName.SCAVENGERS, Factory: Scavengers_1.Scavengers },
    ],
    cardsToRemove: [
        CardName_1.CardName.PHOBOS_SPACE_HAVEN,
    ],
});
//# sourceMappingURL=LeagueCardManifest.js.map